<template>
    <div class="sw-modal">
        <div v-click-outside="cancel" class="sw-modal-content edit-form-component">
            <div class="row sw-modal-heading">
                <div class="col">
                    <h4>Change password</h4>
                </div>
            </div>
            <div class="sw-modal-body">
                <ValidationObserver ref="changePasswordForm">
                    <form v-on:submit.prevent="changePassword()">
                        <ul>
                            <ValidationObserver>
                                <li class="row question">
                                    <label for="old-password" class="col-12 question__question">Current password</label>
                                    <div class="col-12">
                                        <ValidationProvider vid="oldPassword" rules="required|min:6" v-slot="{ errors }">
                                            <input v-model="oldPassword" id="old-password" type="password" class="form-account__text">
                                            <span class="form__error" v-if="errors">{{ errors[0] }}</span>
                                        </ValidationProvider>
                                    </div>
                                </li>
                                <li class="row"><hr class="col-6"></li>
                                <li class="row question">
                                    <label for="new-password" class="col-12 question__question">Choose a new password</label>
                                    <div class="col-12">
                                        <ValidationProvider vid="newPassword" rules="required|differs:@oldPassword|min:6" v-slot="{ errors }">
                                            <input v-model="newPassword" id="new-password" type="password" class="form-account__text">
                                            <span class="form__error" v-if="errors">{{ errors[0] }}</span>
                                        </ValidationProvider>
                                    </div>
                                </li>
                                <li class="row question">
                                    <label for="confirm-password" class="col-12 question__question">Confirm new password</label>
                                    <div class="col-12">
                                        <ValidationProvider rules="required|confirm:@newPassword|min:6" v-slot="{ errors }">
                                            <input v-model="confirmNewPassword" id="confirm-password" type="password" class="form-account__text">
                                            <span class="form__error" v-if="errors">{{ errors[0] }}</span>
                                        </ValidationProvider>
                                    </div>
                                </li>
                            </ValidationObserver>
                        </ul>

                        <div class="row">
                            <div class="col-12">
                                <div v-if="updating || error || success" class="infobar" v-bind:class="{'infobar-info' : updating || success, 'infobar-error' : error}">
                                    {{infoMessage}}
                                </div>
                            </div>
                        </div>

                        <div v-show="updating">
                            <Spinner/>
                        </div>
                    </form>
                </ValidationObserver>

                <div class="sw-modal-actions">
                    <div class="row" v-show="!updating && !success">
                        <div class="col-6">
                            <button class="btn btn-secondary" v-on:click.stop="cancel()">Cancel</button>
                        </div>
                        <div class="col-6">
                            <button class="btn btn-primary" v-on:click.stop="changePassword()">Update</button>
                        </div>
                    </div>
                    <div class="row" v-show="success">
                        <div class="col-12">
                            <button class="btn btn-primary" v-on:click.stop="cancel()">Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { store } from '@/store.js'

    import Spinner from './Spinner.vue'
    import { ValidationObserver, ValidationProvider } from 'vee-validate'

    export default {
        name: 'ChangePassword',
        components: { ValidationObserver, ValidationProvider, Spinner },
        props: {
        },
        data: function() {
            return {
                oldPassword: "",
                newPassword: "",
                confirmNewPassword: "",
                updating: false,
                error: false,
                success: false,
                infoMessage: ""
            }
        },
        computed: {
        },
        methods: {
            cancel: function() {
                this.$root.$emit('finished-changing-password');
            },
            changePassword: function() {
                this.$refs.changePasswordForm.validate().then(success => {
                    if (!success) {
                        return
                    }
                    this.updating = true;
                    this.error = false;
                    this.infoMessage = "Updating password";
                    const body = {
                        oldPassword: this.oldPassword,
                        newPassword: this.newPassword,
                    }

                    this.$http.post('/guest-management/v1/users/' + store.host.reference + '/change-password', body
                    ).then(() => {
                        this.updating = false;
                        this.success = true;
                        this.infoMessage = "Password updated";
                    }).catch(error => {
                        this.updating = false;
                        this.error = true;
                        if (error.response && error.response.data.message) {
                            this.infoMessage = error.response.data.message
                        } else {
                            this.infoMessage = "Sorry, we can't seem to reach our servers! Please try again"
                        }
                    })

                });
            }
        },
        mounted() {
        }
    }
</script>

<style lang="scss" scoped>
    @import "../styles/layout/forms";
    @import "../styles/components/modal";
    @import "../styles/components/edit_form_component";
</style>